import auth from '@/Data/Functions/auth';
import VersionChecker from '@/Data/WebWorkers/VersionChecker';

export default {
    data() {
        return {
            idleWorkerVersionChecker: {
                worker: null,
                buildTimestamp: 0,
                workerTimeStamp: 0
            }
        };
    },
    watch: {
        '$route.fullPath'() {
            this.clearAppVersionWorker();
            this.initAppVersionWorker();
        }
    },
    created() {
        this.setAppVersion()
            .then(() => {
                this.initAppVersionWorker();
            });
    },
    methods: {
        setAppVersion() {
            return this.$api.get(this.$root.apiUrls.version, this.Ignore401Errors)
                .then(response => {
                    this.idleWorkerVersionChecker.buildTimestamp = response.data.buildUnix;
                })
                .catch(error => {
                    if ([401, 403].includes(error.status) && this.idleWorkerVersionChecker.worker != null) {
                        this.idleWorkerVersionChecker.worker.terminate();
                    }
                });
        },
        clearAppVersionWorker() {
            if (this.idleWorkerVersionChecker.worker != null) {
                this.idleWorkerVersionChecker.worker.terminate();
            }

            this.idleWorkerVersionChecker.worker = null;
            window.appVersionWorkerSet = false;
        },
        initAppVersionWorker() {
            this.clearAppVersionWorker();
            window.appVersionWorkerSet = true;
            const token = auth.get();

            this.idleWorkerVersionChecker.worker = new Worker(window.URL.createObjectURL(VersionChecker(this.$root.apiUrls.version, token)), { name: 'VersionWorker' });
            this.idleWorkerVersionChecker.worker.onmessage = (event) => {
                this.idleWorkerVersionChecker.workerTimeStamp = event.data.buildUnix;

                if (this.showAppReloadOverlay) {
                    this.clearAppVersionWorker();
                }

                if (auth.get() !== token) {
                    this.clearAppVersionWorker();
                    this.initAppVersionWorker();
                }
            };
        }
    }
};
